(function() { module.exports = window["Dexie"]; }());